// extracted by mini-css-extract-plugin
export var cardContainer = "_rd-0";
export var cardHeader = "_rd-2";
export var collapsedState = "_rd-3";
export var dragHandle = "_rd-5";
export var dragHandleIcon = "_rd-6";
export var dragging = "_rd-1";
export var titleArea = "_rd-4";